// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#dashboard {\n  padding: 0 104px;\n}\n.fs-1 {\n  letter-spacing: 0.01em;\n}\n.order-4 {\n  order: 4;\n}\n.order-5 {\n  order: 5;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
